// Consolidated mock data for the new Industrial Solutions page.

export const industrialPageDataNew = {
  themeColor: "#DA291C",

  breadcrumbs: [
    {
      text: "HOME",
      url: "/"
    },
    {
      text: "FOR PROS",
      url: null
    },
    {
      text: "INDUSTRIAL SOLUTIONS",
      url: null
    }
  ],

  heroCTAs: {
    topButton: {
      text: "REQUEST SAMPLES",
      url: "/industrial/samplesrequest/"
    },
    mainButtons: [
      {
        text: "ASK A TECHNICAL SPECIALIST",
        url: "/industrial/technicalspecialist/",
        variant: "outline"
      },
      {
        text: "REQUEST A SITE ASSESSMENT",
        url: "#site-assessment-form",
        variant: "red"
      }
    ]
  },

  components: [
    {
      component: "cardDeck",
      variant: "base",
      id: "industries-served",
      title: "INDUSTRIES SERVED",
      isCarousel: true,
      body: "WD-40 Specialist products are engineered to meet the rigorous demands of various industries, providing specialized solutions for maintenance and repair tasks. Industries that benefit from these products include:",
      cards: [
        {
          id: "metal-fab",
          title: "METAL FABRICATION",
          description: "Custom and high-volume metal fabrication",
          image: "/img/industrial-page/new/Industrial Solutions Metal Fab Image.png",
          linkUrl: "/metal-fabrication"
        },
        {
          id: "oil-gas",
          title: "OIL & GAS",
          description: "Energy exploration, extraction, and processing",
          image: "/img/industrial-page/new/Industrial Solutions Oil Gas Image.png",
          linkUrl: "/oil-and-gas"
        },
        {
          id: "heavy-mfg",
          title: "HEAVY MANUFACTURING",
          description: "Solutions for demanding manufacturing needs",
          image: "/img/industrial-page/new/Industrial Solutions Heavy MFG Image.png",
          linkUrl: "/heavy-manufacturing"
        },
        {
          id: "food-bev",
          title: "FOOD & BEVERAGE",
          description: "Safe, scalable food manufacturing solutions",
          image: "/img/industrial-page/new/Industrial Solutions Food - Bev Image 1.png",
          linkUrl: "/food-and-beverage"
        },
        {
          id: "transportation",
          title: "TRANSPORTATION",
          description: "Reliable performance for road, rail, and fleet operations",
          image: "/img/industrial-page/new/Industrial Solutions Transportation Image.png",
          linkUrl: "/transportation"
        }
      ]
    },
    {
      component: "fullWidthCTA",
      id: "product-guide",
      title: "TRUSTED SOLUTIONS FOR INDUSTRIAL-GRADE PERFORMANCE",
      buttons: [
        {
          text: "DOWNLOAD PRODUCT GUIDE",
          url: "https://files.wd40.com/pdf/industrial/industrial-guide.pdf?_gl=1*345tyt*_gcl_au*NjgzODE4ODQxLjE3NDIzMDcwMjA.*_ga*Njg0NzcxNzcyLjE3NDIzMDcwMjA.*_ga_DDQGDT9LXF*MTc0MzA4MTAwMC40LjEuMTc0MzA4Mjg2Ni4zMC4wLjE1MzY3MjYzMDQ.",
          isSecondary: false
        }
      ]
    },
    {
      component: "cardDeck",
      variant: "vertical",
      id: "product-lines",
      eyebrow: "YOU KNOW THE WD-40 BRAND NAME —",
      title: "BUT DO YOU KNOW EVERYTHING IT CAN DO FOR YOUR INDUSTRIAL JOBS?",
      body: "For over 70 years, our time-tested formulas have helped professionals across industries solve their toughest maintenance challenges. With versatile delivery systems and a powerful line of specialized formulas, WD-40 Specialist helps increase efficiency, reduce downtime, and minimize risk—giving MRO pros the tools they need to get the Job Done Right®.",
      cards: [
        {
          id: "clean-degrease",
          image: "/img/industrial-page/new/Industrial Solutions - Degreasers Image.png",
          title: "CLEANERS & DEGREASERS",
          description: "Remove grease, grime, and contaminants fast",
          linkUrl: "/products/?functionality=clean-degrease"
        },
        {
          id: "lube-penetrants",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "LUBRICANTS & PENETRANTS",
          description: "Free stuck parts and reduce friction",
          linkUrl: "/products/?functionality=lubricates%2Cpenetrate-loosen"
        },
        {
          id: "rust-solutions",
          image: "/img/industrial-page/new/Industrial Solutions - Rust Solutions Image.png",
          title: "RUST SOLUTIONS",
          description: "Stop rust and protect metal surfaces",
          linkUrl: "/products"
        }
      ],
      ctaText: "BROWSE ALL INDUSTRIAL PRODUCTS",
      ctaUrl: "/products/"
    },
    {
      component: "cardDeck",
      variant: "badges",
      id: "badges-card-deck",
      title: "Introducing<br>the WD-40 Brand<br>Job Done Right® System",
      subtitle: "Experience a comprehensive solution designed to protect your equipment at every stage.",
      body: "This end-to-end approach ensures optimal performance, reduces the risk of failures, and keeps your machinery running smoothly.",
      extraImages: [
        "/img/industrial-page/new/WD40 - PCLP Graphic_v3 1.png",
        "/img/industrial-page/new/WD-40 Specialist Line 2.png"
      ],
      cards: [
        {
          id: "prep-it",
          image: "/img/industrial-page/new/Industrial Solutions - Prep It - Image.png",
          title: "Prep It",
          description: "Start every job with thorough preparation",
          linkUrl: "#"
        },
        {
          id: "clean-it",
          image: "/img/industrial-page/new/Industrial Solutions - Clean It - Image.png",
          title: "Clean It",
          description: "Clean your surface for optimal lubrication",
          linkUrl: "#"
        },
        {
          id: "lube-it",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "Lube It",
          description: "Experience superior performance with the best lubrication products on the market",
          linkUrl: "#"
        },
        {
          id: "protect-it",
          image: "/img/industrial-page/new/Industrial Solutions - Protect It - Image.png",
          title: "Protect It",
          description: "Safeguard your hard work with the trusted protection of the WD-40 Brand",
          linkUrl: "#"
        }
      ]
    },
    {
      component: "fullWidthCTA",
      id: "safety-efficiency",
      title: "SOLUTIONS TO MAXIMIZE SAFETY & EFFICIENCY",
      buttons: [
        {
          text: "SAFETY DATA SHEETS",
          url: "https://wd40company.com/partners-suppliers/safety-data-sheets/?region=USA",
          isSecondary: true
        },
        {
          text: "REQUEST SAMPLES",
          url: "/industrial/samplesrequest/",
          isSecondary: false
        }
      ]
    },
    {
      component: "video",
      id: "extend-equipment-life",
      title: "EXTEND THE LIFE OF YOUR EQUIPMENT",
      body: "In demanding environments—like automotive, chemical processing, or high-temperature applications—systems and components face constant wear and degradation. That's why WD-40 Specialist products are engineered to deliver sustainable solutions that extend the life of parts, assemblies, and equipment across industries. From corrosion protection to lubrication and cleaning, discover how WD-40 Specialist products can help you tackle your toughest facility maintenance challenges with confidence.",
      videoUrl: "https://www.youtube.com/watch?v=AfPh-Ynxf-Y&t=11s",
      thumbnailImage: "/img/industrial-page/new/Industrial Solutions by WD-40 video 1.png"
    },
    {
      component: "cardDeck",
      variant: "icons",
      id: "facility-applications",
      title: "FACILITY APPLICATIONS",
      cards: [
        {
          id: "conveyor-systems",
          image: "/img/industrial-page/new/Conveyor Systems Icon.png",
          title: "CONVEYOR SYSTEMS",
          subtitle: "KEEP OPERATIONS MOVING SMOOTHLY.",
          description: '<a href="/products/?category=specialist" target="_blank" rel="noopener noreferrer">WD-40 Specialist lubricants</a> are engineered to reduce friction, resist wear, and protect against moisture and corrosion, helping extend equipment life and maintain peak performance in high-throughput environments.',
          linkUrl: "#"
        },
        {
          id: "electrical-systems",
          image: "/img/industrial-page/new/Electrical Systems Icon.png",
          title: "ELECTRICAL SYSTEMS",
          subtitle: "PROTECT CRITICAL ELECTRICAL COMPONENTS.",
          description: '<a href="/products/contact-cleaner/" target="_blank" rel="noopener noreferrer">WD-40 Specialist Contact Cleaner</a> is formulated to safely clean sensitive components without residue, helping restore performance and ensure reliable operation in control panels, connectors, switches, and circuit boards.',
          linkUrl: "#"
        },
        {
          id: "general-maintenance",
          image: "/img/industrial-page/new/General Maintence Icon.png",
          title: "GENERAL MAINTENANCE",
          subtitle: "BUILT FOR EVERYDAY INDUSTRIAL DEMANDS.",
          description: '<a href="/products/?category=specialist" target="_blank" rel="noopener noreferrer">WD-40 Specialist</a> offers a full line of high-performance solutions—including penetrants, degreasers, lubricants, and rust inhibitors—designed to help maintenance teams stay ahead of wear and tear, reduce downtime, and keep operations running efficiently.',
          linkUrl: "#"
        }
      ]
    },
    {
      component: "fullWidthCTA",
      id: "facility-map",
      title: "SOLUTIONS TO EVERY AREA OF YOUR FACILITY",
      buttons: [
        {
          text: "DOWNLOAD FACILITY MAP",
          url: "https://www.datocms-assets.com/10845/1725637043-facility-full-of-uses.pdf",
          isSecondary: false
        }
      ]
    },
    {
      component: "NumberedStepsList",
      id: "trial-program",
      eyebrow: "PREP IT. CLEAN IT. LUBE IT. PROTECT IT.",
      title: "WD-40 BRAND JOB DONE RIGHT TRIAL PROGRAM",
      subtitle: "GET INDUSTRIAL-STRENGTH PERFORMANCE, PROVEN IN YOUR FACILITY.",
      body: "The WD-40 Specialist product line is built to handle the toughest maintenance challenges across industries. Now, with our Job Done Right Trial Program, you can put our solutions to the test—right on your floor, with your team, and your toughest jobs.",
      steps: [
        {
          number: "1",
          title: "ON-SITE ASSESSMENT",
          description: "Our experts visit your facility to understand your systems, challenges, and performance goals. From conveyor lines to electrical panels, we evaluate where you need support most."
        },
        {
          number: "2",
          title: "TAILORED RECOMMENDATIONS BY PRODUCT CATEGORY",
          description: "We match WD-40 Specialist solutions to your specific needs:",
          bulletPoints: [
            {
              title: "Cleaners & Degreasers",
              description: "Remove grease, grime, and contaminants fast"
            },
            {
              title: "Lubricants & Penetrants",
              description: "Free stuck parts and reduce friction"
            },
            {
              title: "Rust Solutions",
              description: "Stop rust and protect metal surfaces"
            }
          ]
        },
        {
          number: "3",
          title: "TRIAL IMPLEMENTATION",
          description: "We'll run a live trial in your environment to demonstrate product performance where it matters most—on the job. You'll receive a detailed Findings Report with key metrics, ROI, and measurable improvements."
        },
        {
          number: "4",
          title: "LONG-TERM OPTIMIZATION",
          description: "The trial is just the beginning. Our team supports your ongoing success with training, product guidance, and evolving solutions as your facility grows."
        }
      ]
    },
    {
      component: "site-assessment-form"
    },
    {
      component: "success-stories"
    },
    {
      component: "cardDeck",
      variant: 'faqs',
      id: "industrial-faqs",
      title: "FREQUENTLY ASKED QUESTIONS",
      cards: [
        {
          id: "faq-1",
          title: "DOES WD-40 BRAND OFFER A FULL LINE OF PRODUCTS?",
          body: "Yes, WD-40 Brand provides a full line of solutions designed to meet various industrial needs. Unlike many competitors who use similar formulas with different names, WD-40 Brand simplifies your product selection with straightforward, effective options."
        },
        {
          id: "faq-2",
          title: "HOW DO WD-40 BRAND SOLUTIONS ADDRESS MOST INDUSTRIAL APPLICATIONS?",
          body: "WD-40 Brand solutions cover the 80/20 rule of applications, meaning we address the most common needs effectively. While competitors often rename similar formulas for specific uses, our straightforward approach helps you find the right product faster."
        },
        {
          id: "faq-3",
          title: "ARE WD-40 BRAND PRODUCTS SAFE AND COMPLIANT WITH REGULATIONS?",
          body: "Absolutely. All WD-40 Brand products are 50-state VOC compliant, and none require a California Prop 65 warning, making them safe for nationwide use. We also provide GHS-approved labels for solutions intended for use in a spray bottle."
        }
      ],
      ctaText: "ASK A TECHNICAL SPECIALIST",
      ctaUrl: "/industrial/technicalspecialist/"
    },
    {
      component: "related-articles"
    }
  ],

};
